import { render, staticRenderFns } from "./InstalikeTooltip.vue?vue&type=template&id=66ce43aa&"
import script from "./InstalikeTooltip.vue?vue&type=script&lang=ts&"
export * from "./InstalikeTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports